export var PlaceMent = ['top', 'bottom'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-mentions/src/placement.js
// module id = null
// module chunks = 